import type { AnySourceConfig, SourceKey } from '../types';
import { registration, REGISTRATION_ENRICHED_KEYS } from './registration';
import { caseSource, CASE_ENRICHED_KEYS } from './case';
import { intake, INTAKE_ENRICHED_KEYS } from './intake';
import { request, REQUEST_ENRICHED_KEYS } from './request';

export const SOURCES: Record<SourceKey, AnySourceConfig> = {
  intake,
  request,
  case: caseSource,
  registration,
};

/** Sources that run the missing-data algorithm, and the columns that trigger it. */
export const ENRICHED_KEYS: Partial<Record<SourceKey, Set<string>>> = {
  request: REQUEST_ENRICHED_KEYS,
  intake: INTAKE_ENRICHED_KEYS,
  case: CASE_ENRICHED_KEYS,
  registration: REGISTRATION_ENRICHED_KEYS,
};
